import { axiosInstance } from '../../../shared/api';

import {
	getIncomesRequest,
	incomesGerCategoriesRequest,
} from '../../Income/api';
import {
	expensesGerCategoriesRequest,
	getExpensesRequest,
} from '../../Expenses/api';
import { getGoalsRequest } from '../../Goals/api';

export async function completeOnboarding(version) {
	try {
		const response = await axiosInstance.post(
			`users/profile/onboarding/complete`,
			{ version },
			{
				withCredentials: true,
			},
		);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.error('Complete onboarding error:', error);
		throw error;
	}
}

export async function getOverviewRequest(
	startDate = null,
	endDate = null,
	currency = null,
) {
	try {
		let url = `overview`;

		// Add query parameters if provided
		const params = new URLSearchParams();
		if (startDate) params.append('start_date', startDate);
		if (endDate) params.append('end_date', endDate);
		if (currency) params.append('currency', currency);

		if (params.toString()) {
			url += `?${params.toString()}`;
		}

		const response = await axiosInstance.get(url);

		return response.data;
	} catch (error) {
		throw new Error(`Failed to get overview data: ${error.message}`);
	}
}

const unwrapList = (response, key) => {
	const list = response?.[key] ?? response?.data ?? response;
	return Array.isArray(list) ? list : [];
};

export async function fetchDashboardData() {
	const [
		incomes,
		expenses,
		goals,
		incomeCategories,
		expenseCategories,
		overview,
	] = await Promise.all([
		getIncomesRequest(),
		getExpensesRequest(),
		getGoalsRequest(),
		incomesGerCategoriesRequest(),
		expensesGerCategoriesRequest(),
		getOverviewRequest(),
	]);

	return {
		incomes: unwrapList(incomes, 'incomes'),
		expenses: unwrapList(expenses, 'expenses'),
		goals: unwrapList(goals, 'goals'),
		incomeCategories: unwrapList(incomeCategories, 'categories'),
		expenseCategories: unwrapList(expenseCategories, 'categories'),
		overview: unwrapList(overview, 'data'),
	};
}
